import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="30"
        cy="30"
        r="29.65"
        transform="rotate(-90 30 30)"
        fill="black"
        fill-opacity="0.4"
        stroke="white"
        stroke-width="0.7"
      />
      <path
        d="M29.1084 25.2031L22.1806 32.4754C22.0647 32.5968 22 32.7582 22 32.926C22 33.0938 22.0647 33.2552 22.1806 33.3766L22.1887 33.3827C22.2447 33.4418 22.3122 33.489 22.3871 33.5212C22.4619 33.5534 22.5425 33.57 22.624 33.57C22.7055 33.57 22.7861 33.5534 22.861 33.5212C22.9358 33.489 23.0033 33.4418 23.0593 33.3827L29.5834 26.5364L36.1035 33.3827C36.1595 33.4418 36.227 33.489 36.3018 33.5212C36.3766 33.5534 36.4573 33.57 36.5387 33.57C36.6202 33.57 36.7008 33.5534 36.7757 33.5212C36.8505 33.489 36.918 33.4418 36.974 33.3827L36.9822 33.3766C37.0981 33.2552 37.1628 33.0938 37.1628 32.926C37.1628 32.7582 37.0981 32.5968 36.9822 32.4754L30.0544 25.2031C29.9934 25.1389 29.9201 25.0878 29.8388 25.0529C29.7574 25.018 29.6699 25 29.5814 25C29.4929 25 29.4053 25.018 29.324 25.0529C29.2427 25.0878 29.1693 25.1389 29.1084 25.2031Z"
        fill="white"
      />
    </svg>
  );
}
